<template>
  <Transition name="modal-grow">
    <div
      v-if="isOpen"
      class="fixed left-0 top-0 z-40 flex h-screen w-screen items-center justify-center bg-neutral-700/20"
      @click="handleBackdropClick"
    >
      <div
        class="modal-content flex max-h-[90vh] max-w-[95%] overflow-auto rounded-r4 bg-background px-spacing_10 md:min-w-[35rem]"
        @click.stop
      >
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  close: [];
}>();

const props = withDefaults(
  defineProps<{
    closeOnClickOutside?: boolean;
  }>(),
  {
    closeOnClickOutside: true,
  },
);

const isOpen = defineModel("isOpen", {
  default: false,
});

const handleBackdropClick = () => {
  if (props.closeOnClickOutside) {
    isOpen.value = false;
    emit("close");
  }
};
</script>
